import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BudgetDefaultRoutingModule } from './budget-default-routing.module';
import { BudgetDefaultComponent } from './budget-default.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule, MomentDateAdapter, MomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule, MatOptionModule, MatRippleModule, MAT_DATE_LOCALE, MatDateFormats, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FuseCardModule } from '@fuse/components/card';
import { FuseAlertModule } from '@fuse/components/alert';
import { MaterialLayoutModule } from 'app/layout/layouts/horizontal/material/material.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { BrowserModule } from '@angular/platform-browser';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FuseHighlightModule } from '@fuse/components/highlight';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { FuseScrollResetModule } from '@fuse/directives/scroll-reset';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { TranslocoModule } from '@ngneat/transloco';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CookieService } from 'ngx-cookie-service';

export const MY_FORMATS: MatDateFormats = {
  parse  : {
      dateInput: 'DD/MM/YYYY'
  }, 
  display: {
    dateInput         : 'DD/MM/YYYY',
    monthYearLabel    : 'MMM YYYY',
    dateA11yLabel     : 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    BudgetDefaultComponent
  ],
  imports: [
    CarouselModule,
    CommonModule,
    BudgetDefaultRoutingModule

     // ,BrowserModule
    // ,BrowserAnimationsModule
    ,MatTabsModule 
    ,MatMomentDateModule
    ,MatButtonModule
    ,MatIconModule
    ,MatToolbarModule
    ,MatProgressSpinnerModule

    ,MatCheckboxModule
    ,MatFormFieldModule
    ,MatInputModule
    ,MatStepperModule
     ,MatDatepickerModule
    ,MatNativeDateModule
    ,MatRippleModule
     ,MatRadioModule
    ,MatSelectModule
    ,MatOptionModule
    ,FuseCardModule
    ,FuseAlertModule
    ,MaterialLayoutModule
    ,MatSidenavModule
    //,MatListModule
    ,MatGridListModule
    ,ReactiveFormsModule 
    ,FuseHighlightModule
   , FuseNavigationModule
    ,FuseScrollResetModule
    ,MatCardModule
    ,TranslocoModule
    // ,BrowserModule,
    //     BrowserAnimationsModule,
    ,MatAutocompleteModule
    ,MatExpansionModule
    //,MatFormFieldHarness

    // BrowserModule, 
    // BrowserAnimationsModule,
    // MatDatepickerModule,
    // MatNativeDateModule,
    // MatFormFieldModule,
    ,MomentDateModule
    // MatInputModule 
    ,MatTooltipModule
  ]
  , providers: [
     
  //Works only mat-datepicker
  // { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS1 },

  // {
  //   // provide: DateAdapter,
  //   provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  //   useClass: MomentDateAdapter,
  //   deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
  //   useValue: { useUtc: true }
  // },
  // { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }

  {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
  },

  {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  CookieService,
  ]
})
export class BudgetDefaultModule { }
